import TalentView from './TalentView';

export default TalentView;
